import { alpha, Box, Stack, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";
import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined';
import ActiveButton from "../buttons/active_button";
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import { numberWithCommas } from "../../utils/stringFormat";
import moment from "moment";

export default function PaymentHistoryItem(props) {
    const { invoice } = props;
    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    return (
        <Stack
            direction={{
                xs: "row",
                sm: "row",
            }}
            alignItems={{
                xs: "start",
                sm: "center",
            }}
            justifyContent={"space-between"}
            sx={{
                padding: {
                    xs: `calc(${Constants.Styles.spacing} * 2)`,
                    sm: `calc(${Constants.Styles.spacing} * 3)`,
                },
                backgroundColor: alpha(Constants.Colors[currentMode].secondary, 0.3),
                border: `1px solid ${Constants.Colors[currentMode].border}`,
                borderRadius: `calc(${Constants.Styles.radius.base} - 2px)`,
            }}
            spacing={1}
        >
            <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={`calc(${Constants.Styles.spacing} * 4)`}
            >
                <Box
                    sx={{
                        width: `calc(${Constants.Styles.spacing} * 10)`,
                        height: `calc(${Constants.Styles.spacing} * 10)`,
                        borderRadius: `calc(${Constants.Styles.radius.base} - 2px)`,
                        backgroundColor: Constants.Colors[currentMode].secondary,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: `1px solid ${Constants.Colors[currentMode].border}`,
                        borderColor: Constants.Colors[currentMode].secondary,
                    }}
                >
                    {<InsertInvitationOutlinedIcon sx={{
                        color: Constants.Colors[currentMode].mutedForeground,
                        fontSize: "1.5rem",
                    }} />}
                </Box>
                <Box>
                    <Typography
                        sx={{
                            fontWeight: Constants.Styles.fontWeight.medium,
                            fontSize: Constants.Styles.fontSize.sm,
                            lineHeight: Constants.Styles.lineHeight.sm,
                            color: Constants.Colors[currentMode].foreground,
                        }}
                    >{moment(invoice?.created * 1000).format("MMM DD, YYYY")}</Typography>
                    <Typography sx={{
                        fontWeight: Constants.Styles.fontWeight.regular,
                        fontSize: Constants.Styles.fontSize.xs,
                        lineHeight: Constants.Styles.lineHeight.xs,
                        color: Constants.Colors[currentMode].mutedForeground,
                    }}>{"Monthly"}</Typography>
                </Box>
            </Stack>
            <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={"1.125rem"}
            >
                <Typography sx={{
                    fontWeight: Constants.Styles.fontWeight.regular,
                    fontSize: Constants.Styles.fontSize.sm,
                    lineHeight: Constants.Styles.lineHeight.sm,
                    color: Constants.Colors[currentMode].foreground,
                }}>{`$${numberWithCommas(invoice?.amount_paid / 100.00)}`}</Typography>
                <ActiveButton
                    text={invoice?.status}
                />
                <RequestQuoteOutlinedIcon sx={{
                    color: Constants.Colors[currentMode].mutedForeground,
                    fontSize: "1.25rem",
                }} />
            </Stack>
        </Stack>
    );
}